import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { Output } from '../types';
import { useProjectStore } from './project';

export const useUIStore = defineStore('ui', () => {
  const projectStore = useProjectStore();

  const selectedItem = ref<string | null>(null);
  const selectedTitle = ref<string | null>(null);
  const selectedContent = ref<string | null>(null);

  const isSelectedOutputStreaming = computed((): boolean => {
    if (!selectedItem.value || !selectedTitle.value) return false;

    const outputKey = selectedItem.value.includes(':')
      ? selectedItem.value
      : `${selectedItem.value}:${selectedTitle.value}`;

    const [frameworkId, outputName] = outputKey.split(':');
    const framework = projectStore.frameworks.find(f => f.frameworkId === frameworkId);
    if (framework) {
      const output = framework.outputs.find(o => o.name === outputName);
      return Boolean(output && output.status === 'started');
    }
    return false;
  });

  const isCostsSelected = computed(() => selectedItem.value === 'costs');

  async function selectOutput(outputKey?: string) {
    let output: Output | undefined;

    if (outputKey === 'manuscript' && projectStore.manuscript) {
      selectedItem.value = 'manuscript';
      selectedTitle.value = 'manuscript';
      selectedContent.value = projectStore.manuscript || '';
    } else if (outputKey === 'costs' && projectStore.costs) {
      selectedItem.value = 'costs';
      selectedTitle.value = 'costs';
      selectedContent.value = projectStore.costs ? JSON.stringify(projectStore.costs, null, 2) : '';
    } else if (outputKey && (output = projectStore.outputs[outputKey])) {
      selectedItem.value = projectStore.outputKeys[outputKey] || outputKey;
      selectedTitle.value = output.name;
      selectedContent.value = output.content;
    } else {
      clearSelection();
    }
  }

  function clearSelection() {
    selectedItem.value = null;
    selectedTitle.value = null;
    selectedContent.value = null;
  }

  return {
    selectedItem,
    selectedTitle,
    selectedContent,
    isSelectedOutputStreaming,
    isCostsSelected,
    selectOutput,
    clearSelection,
  };
});
